import { default as punishmentListTypes } from "./types";

const {
  FETCH_PUNISHMENT_LIST_REQUEST,
  FETCH_PUNISHMENT_LIST_SUCCESS,
  FETCH_PUNISHMENT_LIST_FAILURE,
} = punishmentListTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PUNISHMENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PUNISHMENT_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_PUNISHMENT_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
